<template>
    <div>
        <div class="row">
            <div class="col-12">
                <h2 class="pull-left">{{ $t('monitoring.title__application_reference') }} {{ MonitoringForm.reference }}</h2>
                <el-select class="pull-right" v-model="visiblePage" placeholder="Select page" v-if="visiblePage !== 'home'">
                    <el-option v-for="(item, key) in pages" :key="key" :label="item" :value="key" />
                </el-select>
            </div>
        </div>
        <div class="row d-flex align-items-stretch" v-if="visiblePage == 'home'">
            <div class="col-lg-3">
                <card class="mt-card" @click.native="visiblePage = 'grant-agreement'">
                    <template slot="header">
                        <h3 class="card-title">{{ $t('monitoring.card_title__grant_agreement') }}</h3>
                    </template>
                    <div>
                    </div>
                </card>
            </div>
            <div class="col-lg-3">
                <card class="mt-card" @click.native="visiblePage = 'approved-logframe'">
                    <template slot="header">
                        <h3 class="card-title">{{ $t('monitoring.card_title__approved_logframe') }}</h3>
                    </template>
                    <div>
                    </div>
                </card>
            </div>
            <!-- <div class="col-lg-3">
                <card class="mt-card" @click.native="visiblePage = 'project-team'">
                    <template slot="header">
                        <h3 class="card-title">Project Team</h3>
                    </template>
                    <div>
                    </div>
                </card>
            </div> -->
            <div class="col-lg-3">
                <card class="mt-card" @click.native="visiblePage = 'reporting'">
                    <template slot="header">
                        <h3 class="card-title">{{ $t('monitoring.card_title__reporting') }}</h3>
                    </template>
                    <!-- <div>
                        <p>{{ $t('monitoring.tabs_label__monthly_report') }}</p>
                        <p>{{ $t('monitoring.tabs_label__technical_report') }}</p>
                        <p>{{ $t('monitoring.tabs_label__financial_report') }}</p>
                    </div> -->
                </card>
            </div>
            <div class="col-lg-3">
                <a href="https://monitoring.app.biopama.org/" target="_blank" class="card-title">
                    <div class="card mt-card">
                        <div class="card-header">
                            <h3 class="card-title">{{ $t('monitoring.card_title__monitoring') }}</h3>
                        </div>
                    </div>
                </a>
            </div>
        </div>
        <page-grant-agreement v-if="visiblePage == 'grant-agreement'"></page-grant-agreement>
        <page-approved-logframe v-if="visiblePage == 'approved-logframe'"></page-approved-logframe>
        <page-reporting v-if="visiblePage == 'reporting'"></page-reporting>
    </div>
</template>
<script>
    import {MonitoringService, MonitoringForm} from '@/services';
    import {Select, Option} from 'element-ui';

    import PageGrantAgreement from './Pages/GrantAgreement';
    import PageApprovedLogframe from './Pages/ApprovedLogframe';
    import PageReporting from './Pages/Reporting';

    export default
    {
        components:
        {
            [Select.name]: Select,
            [Option.name]: Option,
            MonitoringForm,
            PageGrantAgreement,
            PageApprovedLogframe,
            PageReporting,
        },
        data()
        {
            return {
                MonitoringForm,
                visiblePage: 'home',
                pages:
                {
                    'home': this.$t('monitoring.card_title__home'),
                    'grant-agreement': this.$t('monitoring.card_title__grant_agreement'),
                    'approved-logframe': this.$t('monitoring.card_title__approved_logframe'),
                    // 'project-team': 'Project Team',
                    'reporting': this.$t('monitoring.card_title__reporting'),
                }
            }
        },
        async beforeCreate()
        {
            const vm = this;
            const loader = vm.$loading.show();

            const response = await MonitoringService.getAwardedApplications();

            if (response)
            {
                vm.applications = response.data;
            }

            if (MonitoringForm.visible_page)
            {
                vm.visiblePage = MonitoringForm.visible_page;
            }

            loader.hide();
        },
        methods:
        {

        },
    };
</script>
<style lang="scss">
    .mt-card
    {
        height: 100%;
    }
</style>
